module.exports = __webpack_public_path__ + "a03a55f863177c68a8865ca6ec17f305.svg";